export const PageContentType = 'page';

export const PageContentTypes = {
    CaseStudy: 'pageCaseStudy',
    Company: 'pageCompany',
    Expertise: 'pageExpertise',
    Industry: 'pageIndustry',
    Journal: 'pageJournal',
    Landing: 'pageLanding',
    Service: 'pageService',
    Technology: 'pageTechnology',
    Person: 'pagePerson',
};
